export class HeadersBuilder {
    constructor(headers = {}) {
        this.headers = {};
        this.headers = headers;
    }
    addJsonContentTypeHeader() {
        this.headers['Content-Type'] = 'application/json';
        return this;
    }
    addUrlEncodedContentTypeHeader() {
        this.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return this;
    }
    addAuthorizationHeader(token) {
        this.headers['Authorization'] = `Bearer ${token}`;
        return this;
    }
    build() {
        return this.headers;
    }
}
